var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star variation (Parent component)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.3773 13.4575L26.5552 13.8037L26.9407 13.8575L37.7306 15.3627C37.7309 15.3628 37.7312 15.3628 37.7316 15.3629C38.097 15.4155 38.2859 15.7191 38.2436 15.9823L38.2435 15.9823L38.2423 15.9909C38.2256 16.1027 38.1699 16.2121 38.0753 16.3013C38.0752 16.3014 38.075 16.3016 38.0749 16.3017L30.2681 23.6079L29.9706 23.8864L30.0423 24.2875L31.887 34.6062L31.8871 34.6068C31.9355 34.8761 31.75 35.1808 31.3934 35.2398L31.3924 35.24C31.253 35.2632 31.1104 35.2407 30.9943 35.1813L30.991 35.1796L21.338 30.3079L21.0001 30.1374L20.6622 30.3079L11.0092 35.1796L11.0081 35.1802C10.9053 35.2323 10.7872 35.2566 10.6677 35.2484C10.5482 35.2403 10.4361 35.2002 10.3439 35.1359C10.2519 35.0718 10.1847 34.9872 10.1455 34.8946C10.1065 34.8024 10.0957 34.7032 10.113 34.6072L10.1132 34.6062L11.9579 24.2875L12.0296 23.8864L11.7321 23.6079L3.92387 16.3004L3.92382 16.3004C3.81056 16.1944 3.75195 16.0563 3.75005 15.9186C3.74815 15.7813 3.80256 15.6427 3.91169 15.5345C4.00456 15.444 4.12782 15.3822 4.26562 15.3633L4.26736 15.363L15.0595 13.8575L15.445 13.8037L15.6229 13.4575L20.4454 4.07275C20.4456 4.07227 20.4459 4.07178 20.4461 4.0713C20.5897 3.79765 20.963 3.66104 21.2825 3.81241L21.2833 3.81282C21.4056 3.87057 21.4983 3.96255 21.5526 4.06841L21.5529 4.06907L26.3773 13.4575Z",
    fill: "#D4AD53",
    stroke: "#D4AD53",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f96b3b3734a8f4293be8887af76f8e94.svg";
export { ForwardRef as ReactComponent };